import Alert from '@material-ui/lab/Alert';
import React, { useState, useEffect } from 'react';
import { TextBox } from './TextBox';
import { Button, Grid, Typography } from '@material-ui/core';
import { DataState } from './dataState';
import { httpPost } from './http';
import { refreshIdentityFromToken } from './auth';

const LoginPage: React.FC<{

}> = ({ }) => {
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const [dataState, setDataState] = useState(new DataState({
		username: '',
		password: ''
	}));

	const handleLogin = async () => {
		setLoading(true);

		try {
			let result = await httpPost(`/identities/login`, dataState.record);
			dataState.validationReset.next();

			if (result.token) {
				localStorage.setItem('jwt', result.token);
				refreshIdentityFromToken();
				document.location = document.location;
			}
		} catch (error) {
			if (error.status == 400) {
				dataState.emitValidationErrors(error.serverError.errors);
			} else {
				setErrorMessage('Neplatné přihlášení');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<form style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }} onSubmit={event => {
			event.preventDefault();
			handleLogin();
		}}>
			<Grid container spacing={4}>
				<Grid item xs={12}>
					<Typography variant="h5">Přihlášení</Typography>
				</Grid>
			</Grid>
			{
				errorMessage &&
				<Grid container spacing={4}>
					<Grid item xs={12}>
						<Alert severity="error">{errorMessage}</Alert>
					</Grid>
				</Grid>
			}
			<Grid container spacing={4}>
				<Grid item xs={12}>
					<TextBox label="E-mail" path="username" dataState={dataState}></TextBox>
				</Grid>
			</Grid>
			<Grid container spacing={4}>
				<Grid item xs={12}>
					<TextBox label="Heslo" type="password" path="password" dataState={dataState}></TextBox>
				</Grid></Grid>
			<Grid container spacing={4}>
				<Grid item xs={12}>
					<Button variant="contained" color="primary" size="large" type="submit" fullWidth={true}>Přihlásit se</Button>
				</Grid>
			</Grid>
		</form>
	);
}

export default LoginPage;
